var _ellipse, _ellipse2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.64045,
    rx: 8,
    ry: 7.64045,
    stroke: "#005068"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99718,
    cy: 14.7345,
    rx: 0.444444,
    ry: 0.424469,
    fill: "#005068"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 13.0355V12.34C9.9987 11.7156 10.3176 11.1346 10.8442 10.7992L11.3967 10.4475C12.1869 9.94437 12.6654 9.07247 12.6654 8.13567V8.06168C12.6654 6.58893 11.4715 5.39502 9.9987 5.39502H9.87885C8.47228 5.39502 7.33203 6.53527 7.33203 7.94184V7.94184",
    stroke: "#005068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiry);
export default __webpack_public_path__ + "static/media/enquiry.4b0d7a553d1e8758e27489474e17fd51.svg";
export { ForwardRef as ReactComponent };